import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { PolicyRoutingModule } from './policy-routing.module';
import { PolicyComponent } from './components/tabs/policy/policy.component';
import { FormTabModule } from 'projects/form-tab/src/public-api';

import { UnderwritingRulesComponent } from './components/core/underwriting-rules/underwriting-rules.component';
import { PolicyErrorsComponent } from './components/policy-errors/policy-errors.component';
import { PolicyEditorComponent } from './core/policy-editor.component';
import { LocationContentComponent } from './components/tabs/location/location-content.component';
import { RatingComponent } from './components/tabs/rating/rating.component';
import { NotesComponent } from './components/tabs/notes/notes.component';
import { AddNoteDialogComponent } from './components/tabs/notes/dialogs/add-note-dialog/add-note-dialog.component';
import { ClaimsContentComponent } from './components/tabs/claims/claims-content.component';
import { InterestsComponent } from './components/tabs/interests/interests.component';
import { RiskDetailsComponent } from './components/tabs/location/subtab/risk-details/risk-details.component';
import { HeatingInfoComponent } from './components/tabs/location/subtab/heating-info/heating-info.component';
import { BuildingDetailsComponent } from './components/tabs/location/subtab/building-details/building-details.component';
import { BuildingCoveragesComponent } from './components/tabs/location/subtab/building-coverages/building-coverages.component';
import { BillingComponent } from './components/tabs/billing/billing.component';
import { CoverageDetailsComponent } from './components/tabs/location/subtab/coverage-details/coverage-details.component';
import { OutbuildingsComponent } from './components/tabs/location/subtab/outbuildings/outbuildings.component';
import { PolicyHeaderComponent } from './components/header/policy-header/policy-header.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { AddressComponent } from './components/tabs/location/subtab/address/address.component';
import { DeleteNodeDialog } from './components/tabs/location/dialogs/delete-node-dialog.component';
import { ErrorDialogComponent } from './components/tabs/rating/dialogs/error-dialog/error-dialog.component';
import { InsuredInformationComponent } from './components/tabs/policy/subtabs/insured-information/insured-information.component';
import { PolicyholderComponent } from './components/tabs/policy/subtabs/policyholder/policyholder.component';
import { MatTreeComponent } from './shared/components/mat-tree/mat-tree.component';
import { NestedMatTreeComponent } from './shared/components/nested-mat-tree/nested-mat-tree.component';
import { FarmRevenueComponent } from './components/tabs/policy/subtabs/farm-revenue/farm-revenue.component';
import { PolicyCoverageComponent } from './components/tabs/policy/subtabs/policy-coverage/policy-coverage.component';
import { FarmActivitiesComponent } from './components/tabs/policy/subtabs/farm-activities/farm-activities.component';
import { FormComponent } from './shared/components/form/form.component';
import { DialogForm } from './shared/components/dialog-form/dialog-form.component';
import { NgxMaskModule } from 'ngx-mask';
import { LiabilityComponent } from './components/tabs/liability/liability/liability.component';
import { CoverageTableComponent } from './shared/components/coverage-table/coverage-table.component';
import { DebugDataComponent, DebugDialog } from './components/debug-data/debug-data.component';
import { ClientComponent } from './components/tabs/client/client.component';
import { NestedSubtabFormComponent } from './shared/components/nested-subtab-form/nested-subtab-form.component';
import { ClaimsFormComponent } from './components/tabs/claims/claims-form/claims-form.component';
import { InterestsFormComponent } from './components/tabs/interests/interests-form/interests-form.component';
import { BasicDialogComponent } from './shared/components/basic-dialog/basic-dialog.component';
import { InterestAllocationTableComponent } from './shared/components/interest-allocation-table/interest-allocation-table.component';
import { ClientInformationComponent } from './components/tabs/client/subtabs/client-information/client-information.component';
import { DialogSearchComponent } from './shared/components/dialog-search/dialog-search.component';
import { ClientSearchComponent } from './components/shared/client-search/client-search.component';
import { ExposureInformationComponent } from './components/tabs/location/subtab/exposure-information/exposure-information.component';
import { LiabilityCoveragesComponent } from './components/tabs/location/subtab/liability-coverages/liability-coverages.component';
import { RatingCoverageTableComponent } from './components/tabs/rating/rating-coverage-table/rating-coverage-table.component';
import { ScheduleItemInformationComponent } from './components/tabs/location/subtab/schedule-item-information/schedule-item-information.component';
import { SupplementInformationComponent } from './components/tabs/location/subtab/supplement-information/supplement-information.component';
import { WatercraftInformationComponent } from './components/tabs/location/subtab/watercraft-information/watercraft-information.component';
import { UnderwriterReviewDialogComponent } from './shared/components/underwriter-review-dialog/underwriter-review-dialog.component';
import { OutbuildingDetailsComponent } from './components/tabs/location/subtab/outbuilding-details/outbuilding-details.component';
import { BrokerReportComponent } from './components/tabs/policy/subtabs/broker-report/broker-report.component';
import { BinsAndSilosDetailsComponent } from './components/tabs/location/subtab/bins-and-silos-details/bins-and-silos-details.component';
import { BinsAndSilosCoverageDetailsComponent } from './components/tabs/location/subtab/bins-and-silos-coverage-details/bins-and-silos-coverage-details.component';
import { GrainDetailsComponent } from './components/tabs/location/subtab/grain-details/grain-details.component';
import { GrainElevatorDetailsComponent } from './components/tabs/location/subtab/grain-elevator-details/grain-elevator-details.component';
import { VehiclesComponent } from './components/tabs/vehicles/vehicles.component';
import { DriversComponent } from './components/tabs/drivers/drivers.component';
import { DriverAssignmentComponent } from './components/tabs/driver-assignment/driver-assignment.component';
import { VehicleDetailsComponent } from './components/tabs/vehicles/vehicle-details/vehicle-details.component';
import { AddVehicleDialogComponent } from './components/tabs/vehicles/add-vehicle-dialog/add-vehicle-dialog.component';
import { DriverDetailsComponent } from './components/tabs/drivers/driver-details/driver-details.component';
import { DocUploadComponent } from './components/tabs/rating/doc-upload/doc-upload.component';
import { DriverSearchComponent } from './components/tabs/drivers/driver-search/driver-search/driver-search.component';
import { SaveTransitionComponent } from './components/save-transition/save-transition.component';

@NgModule({
  declarations: [
    PolicyComponent,
    UnderwritingRulesComponent,
    PolicyErrorsComponent,
    PolicyEditorComponent,
    SaveTransitionComponent,
    LocationContentComponent,
    RatingComponent,
    RatingCoverageTableComponent,
    ClaimsContentComponent,
    NotesComponent,
    AddNoteDialogComponent,
    InterestsComponent,
    RiskDetailsComponent,
    BuildingDetailsComponent,
    BuildingCoveragesComponent,
    BillingComponent,
    HeatingInfoComponent,
    ScheduleItemInformationComponent,
    SupplementInformationComponent,
    WatercraftInformationComponent,
    OutbuildingDetailsComponent,
    DeleteNodeDialog,
    CoverageDetailsComponent,
    OutbuildingsComponent,
    PolicyHeaderComponent,
    NavBarComponent,
    AddressComponent,
    ErrorDialogComponent,
    InsuredInformationComponent,
    PolicyholderComponent,
    MatTreeComponent,
    NestedMatTreeComponent,
    FarmRevenueComponent,
    PolicyCoverageComponent,
    FarmActivitiesComponent,
    FormComponent,
    DialogForm,
    DebugDialog,
    LiabilityComponent,
    CoverageTableComponent,
    DebugDataComponent,
    ClientComponent,
    NestedSubtabFormComponent,
    ClaimsFormComponent,
    InterestsFormComponent,
    BasicDialogComponent,
    UnderwriterReviewDialogComponent,
    InterestAllocationTableComponent,
    ClientInformationComponent,
    DialogSearchComponent,
    ClientSearchComponent,
    ExposureInformationComponent,
    LiabilityCoveragesComponent,
    BrokerReportComponent,
    BinsAndSilosDetailsComponent,
    BinsAndSilosCoverageDetailsComponent,
    GrainDetailsComponent,
    GrainElevatorDetailsComponent,
    VehiclesComponent,
    DriversComponent,
    DriverAssignmentComponent,
    VehicleDetailsComponent,
    AddVehicleDialogComponent,
    DriverDetailsComponent,
    DocUploadComponent,
    DriverSearchComponent
  ],
  imports: [
    CommonModule,
    PolicyRoutingModule,
    CoreModule,
    SharedModule,
    FormTabModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    MatTabsModule,
    MatExpansionModule,
    MatSidenavModule,
    MatIconModule,
    MatChipsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatProgressBarModule,
    NgxMaskModule.forRoot({
      showMaskTyped: true
    }),
  ],
  entryComponents: [
    AddNoteDialogComponent,
    DeleteNodeDialog,
    ErrorDialogComponent,
    DialogForm,
    DebugDialog,
    DialogSearchComponent,
    BasicDialogComponent,
    UnderwriterReviewDialogComponent,
    AddVehicleDialogComponent
  ],
  providers: [
  ],
})
export class PolicyModule { }
